import { mapDtoToJobOrderApplication } from 'modules/jobOrderApply/types/JobOrderApplication.type';
import { ListJobOrderFragment } from 'shared/hooks/api/listJobOrderFragment/listJobOrderFragment.generated';
import { WorkTypeEnum } from 'types/enums/work-type.enum';
import { JobOrderListItem } from './JobOrderListItem';

export const mapDtoToJobOrderListItem = (dto: ListJobOrderFragment): JobOrderListItem => ({
  id: dto.jobOrderId,
  name: dto.jobOrderLabel,
  createdAt: new Date(dto.assignmentDate),
  seniority: dto.seniority ?? null,
  experienceYears: dto.experienceYears ?? null,
  locationPreference: dto.locationPreference ?? null,
  minEnglishLevel: dto.minEnglishLevel ?? null,
  workType: (dto.workMode as unknown as WorkTypeEnum) ?? null,
  rateRangeFrom: dto.rateRangeFrom ?? 0,
  rateRangeTo: dto.rateRangeTo ?? 0,
  isObserved: dto.isSaved ?? false,
  application: dto.application ? mapDtoToJobOrderApplication(dto.application) : null,
  isAIRAvailable: dto.isAIRAvailable ?? false,
});
